import MultiPosePackageBuilder from './MultiPosePackageBuilder';

export default MultiPosePackageBuilder;
